import React from 'react';
import { zoneSearchAPI } from 'src/api/ZoneApi';
import FormikSearchDropdown from 'src/components/formik/FormikSearchDropdown/FormikSearchDropdown';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import PropTypes from 'prop-types';

const ZoneDropDown = ({ value, name, readOnly }) => (
    <FormikSearchDropdown
        name={name}
        placeholder="Select Zone"
        displayKeyPath={[
            'zoneName',
        ]}
        valueKeyPath="_id"
        defaultValueFetchByKeyPath="_id"
        whereClauseKeysPaths={[
            'zoneName',
        ]}
        api={zoneSearchAPI}
        apiCallAddonData={{
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
        }}
        value={value}
        disabled={readOnly}
    />
);

ZoneDropDown.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    value: PropTypes.any,
    name: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
};

ZoneDropDown.defaultProps = {
    value: '',
    readOnly: false,
};

export default ZoneDropDown;
